import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { theme } from '../../styles/GlobalStyles';

const CTA = styled.a`
  background: ${theme.hover.hoverBlue};
  padding: 10.5px 24px 12px;
  color: ${theme.heading.dark};
  border-radius: 20px;
  text-decoration: none;

  &:hover,
  &:active,
  &:focus {
    background-color: ${theme.hover.hoverLight};
    cursor: pointer;
  }
`;

const CallToAction = ({ text, link }) => (
  <CTA
    target="_blank"
    rel="noopener noreferrer"
    href={link}
  >
    { text }
  </CTA>
);

export default CallToAction;

CallToAction.propTypes = {
  text: PropTypes.string.isRequired,
  link: PropTypes.string,
};

CallToAction.defaultProps = {
  link: 'https://my.workast.io/slack/install?_ga=2.157793978.1258453354.1597084599-1572877097.1596510761'
};
